/**
 * Created by coolguy on 2017/7/27.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('agreement');
const AGREEMENT_LIST = "AGREEMENT_LIST";
const AGREEMENT_ADD = "AGREEMENT_ADD";
const AGREEMENT_DELETE = "AGREEMENT_DELETE";
const AGREEMENT_EDIT = "AGREEMENT_EDIT";
const AGREEMENT_DETAIL = "AGREEMENT_DETAIL";

export default {
    AGREEMENT_LIST,
    agreementList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            api:TheApi('get')(),
            data:search,
            success: (data)=>({
                type:AGREEMENT_LIST,
                data
            })
        })
    },
    AGREEMENT_ADD,
    agreementAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:AGREEMENT_ADD,
                data
            })
        })
    },
    AGREEMENT_DELETE,
    agreementDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:AGREEMENT_DELETE,
                data,
            })
        })
    },
    AGREEMENT_EDIT,
    agreementEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:AGREEMENT_EDIT,
                data,
            })
        })
    },
    AGREEMENT_DETAIL,
    agreementDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:AGREEMENT_DETAIL,
                data,
            })
        })
    },
}


// WEBPACK FOOTER //
// ./src/actions/AgreementAction.js